import { render, staticRenderFns } from "./productAddDialog.vue?vue&type=template&id=3caef549&scoped=true"
import script from "./productAddDialog.vue?vue&type=script&lang=js"
export * from "./productAddDialog.vue?vue&type=script&lang=js"
import style0 from "./productAddDialog.vue?vue&type=style&index=0&id=3caef549&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caef549",
  null
  
)

export default component.exports